import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import ActivityLogs from "../pages/Admin/ActivityLogs/ActivityLogs";
import BulkUpload from "../pages/Admin/BulkUpload/BulkUpload";
import CertificateActivityLogs from "../pages/Admin/Certificate/CertificateActivityLogs/CertificateActivityLogs";
import CertificateList from "../pages/Admin/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/Admin/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/Admin/Certificate/ViewCertificate/ViewCertificate";
import CertificateEntity from "../pages/Admin/CertificateEntity/CertificateEntity";
import CertificateTemplate from "../pages/Admin/CertificateTemplate/CertificateTemplate";
import CertificateTemplateEdit from "../pages/Admin/CertificateTemplate/CertificateTemplateEdit/CertificateTemplateEdit";
import CertificateTemplateVersion from "../pages/Admin/CertificateTemplate/CertificateTemplateVersion/CertificateTemplateVersion";
import EditCertificateTemplateVersion from "../pages/Admin/CertificateTemplate/CertificateTemplateVersion/EditCertificateTemplateVersion/EditCertificateTemplateVersion";
import CertificateType from "../pages/Admin/CertificateType/CertificateType";
import Course from "../pages/Admin/Course/Course";
import Dashboard from "../pages/Admin/Dashboard/Dashboard";
import Lookup from "../pages/Admin/Lookup/Lookup";
import Profile from "../pages/Admin/Profile/Profile";
import UserActivityLogs from "../pages/Admin/Profile/UserActivityLogs/UserActivityLogs";
import EditStaff from "../pages/Admin/Staff/EditStaff/EditStaff";
import Staff from "../pages/Admin/Staff/Staff";

var AdminRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <Dashboard/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "bulk-upload",
    name: "Bulk Upload",
    element: <BulkUpload/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "staff",
    name: "Staff",
    element: <Staff/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "course",
    name: "Course",
    element: <Course/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificte-entity",
    name: "Certificate Entity",
    element: <CertificateEntity/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificte-type",
    name: "Certificate Type",
    element: <CertificateType/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificate-template",
    name: "Certificate Templates",
    element: <CertificateTemplate />,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "activity-logs",
    name: "Activity Logs",
    element: <ActivityLogs/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "look-ups",
    name: "Look Ups",
    element: <Lookup/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "certificate-template/:id",
    name: "Certificate Template",
    element: <CertificateTemplateEdit/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/activity-logs/:certificate_id",
    name: "Certificate Activity Logs",
    element: <CertificateActivityLogs/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-activities",
    name: "Activity Logs",
    element: <UserActivityLogs/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "staff/:id",
    name: "Staff Member",
    element: <EditStaff/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },   
  {
    path: "certificate-template/:id/versions",
    name: "Certificate Template Versions",
    element: <CertificateTemplateVersion/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },  
  {
    path: "certificate-template/:id/versions/:versionId",
    name: "Certificate Template Versions",
    element: <EditCertificateTemplateVersion/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "my-profile",
    name: "Profile",
    element: <Profile/>,
    layout: "admin",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
];
export default AdminRoutes;
